import { render } from "./caseA.vue?vue&type=template&id=43ca91f6&scoped=true"
import script from "./caseA.vue?vue&type=script&lang=js"
export * from "./caseA.vue?vue&type=script&lang=js"

import "./caseA.vue?vue&type=style&index=0&id=43ca91f6&scoped=true&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ca91f6"]])

export default __exports__